import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'Eyebrow',
})(({ spacing, brandColors }) => ({
  eyebrow: {
    textTransform: 'uppercase',
    marginTop: spacing(0),
    marginBottom: spacing(-1),
  },
  onDark: {
    color: brandColors.tintsOffWhite40,
  },
  onLight: {
    color: brandColors.tintsNeutral20,
  },
}));

export default useStyles;
